var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard-wrapper"},[_c('div',{staticClass:"leaderboard"},[_c('Adsense',{attrs:{"data-ad-format":"horizontal","data-ad-client":"ca-pub-9822209171586486","data-ad-slot":"5964623418"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }